import React from 'react';

import classNames from 'classnames';
import SanitizedHTML from 'components/ui/sanitized_html';

import ActionConfirmations from './action_confirmations';
import SparkBadge from '../spark_badge';
import { AI_HTML_OPTIONS } from 'components/ai/html';
import { InlineTools } from '../tools/inline';
import { StepCard, liveSteps } from '../tools/inline/step_card';
import { formatMetrics } from '../metrics/helpers';
import { useConversationContext } from '../conversation_context';

import type { Message } from '../types';

interface Props {
  message: Message;
  superseded: boolean;
}

export default function AssistantMessage({ message, superseded }: Props) {
  const { busy, resolveAction, showAdminDetails } = useConversationContext();
  const runningSteps = liveSteps(message.steps, message.inlineToolCalls);

  return (
    <div className="d-flex gap-2 mb-3">
      <SparkBadge className="flex-shrink-0 align-self-start" />
      <div className={classNames({ 'text-danger': message.error })} style={{ maxWidth: '85%' }}>
        <InlineTools superseded={superseded} toolCalls={message.inlineToolCalls || []} />
        {runningSteps && <StepCard steps={runningSteps} />}
        {message.content && (
          <SanitizedHTML
            className={classNames('ai-assistant-prose', {
              'is-streaming': message.isStreaming && !message.status,
            })}
            html={message.content}
            {...AI_HTML_OPTIONS}
          />
        )}
        {message.actions && message.actions.length > 0 && (
          <ActionConfirmations actions={message.actions} disabled={busy} onResolve={resolveAction} />
        )}
        {message.isStreaming && !runningSteps && (message.status || !message.content) && (
          <div className="small mt-1">
            <span className="ai-assistant-thinking">{message.status || 'Thinking'}…</span>
          </div>
        )}
        {showAdminDetails && message.metrics && (
          <div className="text-muted small mt-1">{formatMetrics(message.metrics)}</div>
        )}
      </div>
    </div>
  );
}
